export default "__VITE_ASSET__XhQSCCzh__"